import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@chakra-ui/react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import Header from '../components/Header'

export default function Root() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  return (
    <>
      <Box
        minHeight="100vh"
        position="relative"
        maxWidth="1024px"
        margin="0 auto"
        padding="10px">
        <Header />
        <Outlet />
        {/* <Footer /> */}
        <ReactQueryDevtools />
      </Box>
    </>
  )
}
